import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { Eye, X } from 'lucide-react';

export default function AppShell() {
  const { user, logout, isImpersonating, stopImpersonation } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const segment = location.pathname.split('/')[2] || 'dashboard';

  const isGlobalAdmin = user?.company?.type === 'ADMIN';

  const NAV_TITLES = {
    dashboard: t('nav.dashboard'),
    shipments: t('nav.shipments'),
    products:  t('nav.products'),
    orders:    t('nav.orders'),
    catalogs:  t('nav.catalogs'),
    invoices:  t('nav.invoices'),
    reporting: t('nav.reporting'),
    claims:    t('nav.claims'),
    messages:  t('nav.messages'),
    users:     isGlobalAdmin ? t('nav.clients') : t('nav.users'),
    roles:     t('nav.roles'),
    settings:  t('nav.settings'),
  };

  async function handleLogout() {
    await logout();
    navigate('/login', { replace: true });
  }

  async function handleStopImpersonation() {
    await stopImpersonation();
    navigate('/dashboard/users', { replace: true });
  }

  function handleNavigate(key) {
    navigate(key === 'dashboard' ? '/dashboard' : `/dashboard/${key}`);
  }

  return (
    <div className="flex h-screen overflow-hidden bg-slate-50">
      <Sidebar active={segment} onNavigate={handleNavigate} user={user} onLogout={handleLogout} />
      <div className="flex-1 flex flex-col overflow-hidden">
        {isImpersonating && (
          <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between text-[12.5px] flex-shrink-0 z-40">
            <div className="flex items-center gap-2">
              <Eye size={14} strokeWidth={2} />
              <span>
                Vue client active — <strong>{user?.company?.name}</strong>
              </span>
            </div>
            <button
              onClick={handleStopImpersonation}
              className="flex items-center gap-1.5 h-6 px-2.5 rounded bg-white/20 hover:bg-white/30 transition font-medium text-[12px]"
            >
              <X size={12} strokeWidth={2} />
              Quitter la vue client
            </button>
          </div>
        )}
        <Topbar title={NAV_TITLES[segment] || segment} notificationCount={2} />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
